import React, { useEffect, useState } from "react";
import { onValue, ref, update } from "firebase/database";
// import Toolbar from "@mui/material/Toolbar";
import {
	DataGrid, GridColDef, GridValueFormatterParams, GridValueGetterParams, GridRenderEditCellParams,
} from "@mui/x-data-grid";
import {
	Box, Button, Grid, Typography, TextField,
} from "@mui/material";
import { getAuth } from "firebase/auth";
import { base, db, editors } from "../firebase.js";
import AppFrame from "./shared/AppFrame";
import SearchBar from "./shared/SearchBar";
import { Subscribtion as SubFirebase } from "../interfaces/firebaseData";
import NewSub from "./shared/NewSub";
import { formatDualCurrency, eurToBgn, BGN_TO_EUR_RATE } from "../utils";


interface Subscribtion extends SubFirebase {
	id: string;
}
interface SubsData {
	[id: string]: SubFirebase
}


// eslint-disable-next-line @typescript-eslint/naming-convention
function Subscriptions() {
	const [rows, setRows] = useState<Subscribtion[]>([]);
	const [open, setOpen] = useState<boolean>(false);
	const [searchValue, setSearchValue] = useState("");
	const columns: GridColDef[] = [
		{
			field: "name",
			headerName: "Име",
			minWidth: 200,
		},
		{
			field: "price",
			headerName: "Цена(€/лв)",
			minWidth: 150,
			editable: true,
			valueFormatter: (params: GridValueFormatterParams) => formatDualCurrency(params.value),
			valueParser: (value: string | number) => {
				// Convert EUR input to BGN for storage
				if (null === value || undefined === value || "" === value) {
					return null;
				}
				const parsed = eurToBgn(value);
				return isNaN(parsed) ? null : parsed;
			},
			renderEditCell: (params: GridRenderEditCellParams) => {
				const canEdit = editors.includes(getAuth()?.currentUser?.email || "");
				// Display EUR value in edit mode
				const eurValue = params.value ? (params.value / BGN_TO_EUR_RATE).toFixed(2) : "";
				return (
					<TextField
						type="number"
						inputProps={{ step: "0.01", style: { padding: "8px" } }}
						defaultValue={eurValue}
						disabled={!canEdit}
						onChange={(e) => {
							if (!canEdit) {
								return;
							}
							const newValue = e.target.value;
							// Only update if it's a valid number or empty (empty will be handled by valueParser)
							const isEmpty = "" === newValue;
							if (isEmpty || !isNaN(Number(newValue))) {
								params.api.setEditCellValue({
									id: params.id,
									field: params.field,
									value: isEmpty ? "" : newValue,
								});
							}
						}}
						variant="standard"
						sx={{ width: "100%" }}
						autoFocus
					/>
				);
			},
		},
		{ field: "daysValid", headerName: "Валидност(дни)", minWidth: 130 },
		{
			field: "maxVisits",
			headerName: "Макс. брой посещения",
			minWidth: 150,
			valueFormatter: (params: GridValueFormatterParams) => (params.value ? params.value : "неограничен"),
		},
		{
			field: "hourStart",
			headerName: "Времева рамка",
			minWidth: 130,
			valueGetter: (params: GridValueGetterParams) => (params.row.hourStart ? `${new Date(params.row.hourStart).getHours()} - ${new Date(params.row.hourEnd).getHours()}ч.` : "няма"),
		},
		{
			field: "note",
			headerName: "Бележка",
			minWidth: 130,
			valueFormatter: (params: GridValueFormatterParams) => (params.value ? params.value : "няма"),
		},
	];

	useEffect(() => {
		const querySubs = ref(db, `${base}/SubscribtionPackets`);
		return onValue(querySubs, (snapshot) => {
			const data: SubsData = snapshot.val();
			if (snapshot.exists()) {
				const newRows: Subscribtion[] = [];
				Object.entries(data).forEach((entry) => {
					const [key, value] = entry;
					newRows.push({
						id: key,
						...value,
					});
				});
				setRows(newRows.filter((row) => !row.inactive).reverse());
			} else {
				setRows([]);
			}
		});
	}, []);

	const handleSearchChange = (event: React.ChangeEvent<HTMLInputElement>) => {
		setSearchValue(event.target.value);
	};

	const filteredRows = rows.filter((row) => {
		return row.name.toLowerCase().includes(searchValue.toLowerCase());
	});

	const processRowUpdate = async (newRow: Subscribtion) => {
		// Validate price is not NaN before updating
		if (isNaN(newRow.price)) {
			throw new Error("Invalid price value");
		}
		// Update Firebase with the new row data
		const { id, ...updateData } = newRow;
		await update(ref(db, `${base}/SubscribtionPackets/${id}`), updateData);
		return newRow;
	};

	const handleProcessRowUpdateError = (error: Error) => {
		console.error("Error updating subscription:", error);
		// You can add user-facing error notification here if needed
	};

	return (
		<AppFrame>
			<NewSub open={open} onClose={() => { setOpen(false); }} />
			<Grid container mb={3} alignItems="flex-start">
				<Box flex={1}>
					<Typography variant="h6">Абонаменти</Typography>
				</Box>
				<Button variant="outlined" onClick={() => setOpen(true)}>Създай нов</Button>
			</Grid>
			<SearchBar value={searchValue} onChange={handleSearchChange} />
			<div style={{
				width: "100%", marginBottom: "40px", marginTop: "20px", height: "calc(100svh - 240px)",
			}}
			>
				<DataGrid
					disableColumnSelector
					rowSelection={false}
					rowHeight={80}
					rows={filteredRows}
					columns={columns}
					processRowUpdate={processRowUpdate}
					onProcessRowUpdateError={handleProcessRowUpdateError}
					initialState={{
						pagination: {
							paginationModel: { page: 0, pageSize: 10 },
						},
					}}
					pageSizeOptions={[10, 20, 50]}
				/>
			</div>
		</AppFrame>
	);
}

export default Subscriptions;
